import * as ng from 'angular';
import {ComponentRegistration, ISiteConfigService} from '../core';
import {ICustomerSettingsService, IToastMessageService} from "../services";
import {IReCaptchaValidationResource} from "../data";
import {IReCaptchaSettings} from "../data/interfaces";

let template = require('./recaptcha.html');

class ReCaptchaComponent extends ComponentRegistration {

    constructor() {
        // Lets use asm-re-captcha mark up name, to avoid a name conflict with
        // the third parthy reCaptcha component.
        super('asmReCaptcha', {
            controller: ReCaptchaController,
            templateUrl: template,
            controllerAs: 'asmReCaptcha',
            bindings: {
                userIdentifier: "=?",
                onValidationSucceeded: "&",
                onValidationFailed: "&"
            }
        });
    }
}
interface IReCaptchaController {
    userIdentifier: string;
    onValidationSucceeded: Function;
    onValidationFailed: Function;
}

class ReCaptchaController implements IReCaptchaController {

    private static $inject: Array<string> = ['$scope', 'SiteConfig', 'CustomerSettings', 'ReCaptchaValidation', '$q', '$log',
        'toastMessageFactory', 'vcRecaptchaService', '$window' ];

    private static  failedToValidateRecaptchaErrorMessage = 'Failed to validate user response to re-captcha challenge.';

    private _userIdentifier: string = '';
    private _onValidationSucceeded: Function;
    private _onValidationFailed: Function;

    private recaptchaSettings: IReCaptchaSettings;
    private recaptchaWidgetId;

    private showRecaptchaV2 : boolean;
    private showRecaptchaV3 : boolean;

    constructor(private $scope: ng.IScope,
                private SiteConfig: ISiteConfigService,
                private CustomerSettings: ICustomerSettingsService,
                private ReCaptchaValidation: IReCaptchaValidationResource,
                private $q: ng.IQService,
                private $log: ng.ILogService,
                private toastMessageFactory: IToastMessageService,
                private vcRecaptchaService,
                private $window) {
        console.log("recaptcha controller loaded.");
    }

    public $onInit(): void {
        this.$window.grecaptcha = null;

        this.userIdentifier = this.userIdentifier || '';
        this.recaptchaSettings = null;
        this.showRecaptchaV2 = false;
        this.showRecaptchaV3 = false;

        this.CustomerSettings.getReCaptchaSettings().then((settingsResponse) => {

            this.recaptchaSettings = settingsResponse;

            if (settingsResponse.isEnabled) {

                this.showRecaptchaV3 = true;

                var recaptchaV3Container =  document.getElementById('recaptchaV3');

                if (recaptchaV3Container) {
                    this.configureRecaptchaV3(this, recaptchaV3Container);
                }
                else {
                    var _this = this;
                    var waitForReCaptchaV3ContainerTimer = setInterval(function () {
                        recaptchaV3Container =  document.getElementById('recaptchaV3');
                        if (recaptchaV3Container) {
                            clearInterval(waitForReCaptchaV3ContainerTimer);
                            _this.configureRecaptchaV3(_this, recaptchaV3Container);
                        }
                    }, 50);
                }
            }
            else if (this.onValidationSucceeded) {
                // If recaptcha is disabled, the user will just pass the empty token to Api service, which
                // will ignore the token.
                this.onValidationSucceeded({args: ''});
            }

        }).catch((e) => {
            this.$log.error(e, 'Failed to load reCaptcha settings.');
            this.toastMessageFactory.showServerError('Failed to load reCaptcha settings.');
        });
    }

    public get userIdentifier() : string {
        return this._userIdentifier;
    }

    public set userIdentifier(value: string) {
        if (!value)
            return;

        this._userIdentifier = value;
    }

    public get onValidationSucceeded() : Function {
        return this._onValidationSucceeded;
    }

    public set onValidationSucceeded(value: Function) {
        this._onValidationSucceeded = value;
    }

    public get onValidationFailed() : Function {
        return this._onValidationFailed;
    }

    public set onValidationFailed(value: Function) {
        this._onValidationFailed = value;
    }

    private configureRecaptchaV3(_this, recaptchaV3Container) {
        // Since this is called in a timer, the value of "this" is undefined
        var script = this.$window.document.createElement('script');
        script.src =  "https://www.google.com/recaptcha/api.js?render=" + this.recaptchaSettings.reCaptcha3PublicKey;
        recaptchaV3Container.appendChild(script);

        var waitForReCaptchaV3 = function() {

            var onRecaptchaV3Loaded = function()
            {
                if (_this.$window.grecaptcha) {
                    _this.$window.grecaptcha.ready(function () {

                        try {
                            // NOTE: using catch() function call after then() wouldn't work (both as it is, or with .$promise.
                            // we have to catch the exception)
                            _this.$window.grecaptcha.execute(_this.recaptchaSettings.reCaptcha3PublicKey, {action: 'homepage'})
                            .then(function (token) {
                                _this.onRecaptchaV3ResponseReady(_this, token);
                            });
                        }
                        catch (e) {
                            var genericMessage =  'Failed to validate reCaptcha V3 token.';

                            if (e)
                                _this.$log.error(e, genericMessage);
                            else
                                _this.$log.error(genericMessage + ' Invalid public key.');

                            _this.onRecaptchaV3ResponseReady(_this, '');
                        }
                    });
                }
                else {
                    _this.onRecaptchaV3ResponseReady(_this, '');
                }
            }

            var timerExecCount = 0;
            var recaptchaScriptLoadedCheckTimer = setInterval(function () {

                ++timerExecCount;

                // if we waited more than 5 seconds or if the recaptcha script is loaded, lets stop the timer.
                // The user will be presenetd with reCaptcha validation control.
                if (timerExecCount >= 20 || _this.$window.grecaptcha) {
                    onRecaptchaV3Loaded();
                    clearInterval(recaptchaScriptLoadedCheckTimer);
                }

            }, 250);
        }

        waitForReCaptchaV3();
    }

    private onRecaptchaV3ResponseReady(_this, token: string) : void {

        // Since this is called in a timer, the value of "this" is undefined, and changes to member variables are not reflected
        // in UI bound elements, unless we update the values in $scope.$apply().
        _this.$scope.$apply(function ( ) {
            _this.showRecaptchaV3 = false;

            if (token && token.length) {

                _this.ReCaptchaValidation.getReCaptcha3TokenValidationResult({id: _this.userIdentifier, token: token}).$promise
                    .then((validationResult) => {
                        if (validationResult.isValid )
                            _this.onValidationSucceeded({args: token});
                        else {
                            _this.showRecaptchaV2 = true;
                            _this.$log.error('Failed to validate reCaptcha V3 token.');
                        }
                    })
                    .catch((e) => {
                        _this.showRecaptchaV2 = true;
                        _this.$log.error(e,'Failed to validate reCaptcha V3 token.');
                    });
            }
            else {
                _this.showRecaptchaV2 = true;
                _this.$log.error('Failed to validate reCaptcha V3 token.');
            }
        })
    }

    private setRecaptchaV2WidgetId(widgetId) {
        this.recaptchaWidgetId = widgetId;
    }

    private onRecaptchaV2Succeeded(response) {

        this.ReCaptchaValidation.getReCaptcha2TokenValidationResult({id: this.userIdentifier, token: response}).$promise
            .then((validationResult) => {
                if (validationResult.isValid)
                    this.onValidationSucceeded({args: response});
                else {
                    this.onReCaptchaV2Failed();
                }
            })
            .catch((e) => {
                this.onReCaptchaV2Failed(e);
        });
    }

    private onReCaptchaV2Failed(excetion: any = null) : void {
        this.vcRecaptchaService.reload(this.recaptchaWidgetId);

        if (excetion)
            this.$log.error(excetion, ReCaptchaController.failedToValidateRecaptchaErrorMessage);
        else
            this.$log.warn(ReCaptchaController.failedToValidateRecaptchaErrorMessage);

        this.toastMessageFactory.showServerError(ReCaptchaController.failedToValidateRecaptchaErrorMessage);

        if (this.onValidationFailed)
            this.onValidationFailed();
    }
}

let reCaptchaComponent = new ReCaptchaComponent();
export default reCaptchaComponent;
export { reCaptchaComponent as ReCaptchaComponent, IReCaptchaController, ReCaptchaController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/user-controls/recaptcha.ts